// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FTytM","questions":"styles_questions__3Vo7_","footer":"styles_footer__3Pec3"};